module.exports = __webpack_public_path__ + "img/hight_level.d84ac02a.svg";